import React from "react";

function PackagingDetails({ object }) {
  return (
    <div className="border rounded  p-2 max-w-3xl mx-auto">
      {/* <h6 className="text-lg font-semibold text-gray-700 mb-4">
        Details - Component
      </h6> */}
      {/* <hr /> */}
      <div className="">
        <p className="m-0">
          <strong className="font-medium">SKU :</strong> {object?.sku}
        </p>
        <p className="m-0">
          <strong className="font-medium">Item Name :</strong>{" "}
          {object?.itemName}
        </p>

        <p className="m-0">
          <strong className="font-medium">Pieces :</strong> {object?.pieces}
        </p>
      </div>
    </div>
  );
}

export default PackagingDetails;
